"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function GoldSupplier(props) {
  return _react2["default"].createElement(
    "svg",
    { className: props.className, width: props.size, height: props.size, viewBox: "0 0 64 64" },
    _react2["default"].createElement("circle", { fill: "#FACE32", cx: "32", cy: "32", r: "32" }),
    _react2["default"].createElement("circle", { fill: "#E3715D", cx: "32", cy: "32", r: "22.667" }),
    _react2["default"].createElement("path", { fill: "#FACE32", d: "M17.333 20L20 30.67h24L46.667 20zM20 33.335L17.333 44h29.334L44 33.336zm8-32.002h8V16h-8zM28 48h8v14.667h-8z" })
  );
}

exports["default"] = GoldSupplier;
module.exports = exports["default"];